import { renderToStaticMarkup } from "react-dom/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRoute, faTachometerAlt, faTruck } from "@fortawesome/free-solid-svg-icons";
import UserDefinedUnits from "../../../common/utils/UserDefinedUnits";
import englishStrings from "../../../locales/languages/en.json";

export const getPlayerTooltipProperties = (player, user) => {
  const game = String(player.game).toLowerCase();
  const numberFormat = new Intl.NumberFormat();
  const distance = (value) =>
    numberFormat.format(UserDefinedUnits.convertDistanceValue(user, game, value));

  return {
    truck_name: [player.truck?.brand, player.truck?.model].filter(Boolean).join(" "),
    speed: Number.isFinite(player.truck?.speed_kmh)
      ? `${distance(player.truck.speed_kmh)} ${UserDefinedUnits.getSpeedUnitLabel(user, game)}`
      : "",
    navigation_distance: Number.isFinite(player.truck?.navigation_distance_km)
      ? `${distance(player.truck.navigation_distance_km)} ${UserDefinedUnits.getDistanceUnitLabel(user, game)}`
      : "",
    company_name: player.company?.name || "",
    company_logo: player.company?.avatar_url || "",
    job_source: player.job
      ? [player.job.source_city_name, player.job.source_company_name].filter(Boolean).join(" / ")
      : "",
    job_destination: player.job
      ? [player.job.destination_city_name, player.job.destination_company_name].filter(Boolean).join(" / ")
      : "",
  };
};

export const createPlayerTooltip = (player, strings = {}) =>
  renderToStaticMarkup(
    <div className="vector-map-tooltip">
      <div className="vector-map-tooltip-row vector-map-tooltip-user">
        {player.avatar_url && <img src={player.avatar_url} alt="" />}
        <span>{player.user_name}</span>
      </div>
      {player.company_name && (
        <div className="vector-map-tooltip-row">
          {player.company_logo && <img src={player.company_logo} alt="" />}
          <span>{player.company_name}</span>
        </div>
      )}
      {player.truck_name && (
        <div className="vector-map-tooltip-row">
          <FontAwesomeIcon icon={faTruck} fixedWidth role="img" aria-hidden={false} aria-label={strings.truck || englishStrings.truck} />
          <span>{player.truck_name}</span>
        </div>
      )}
      {player.speed && (
        <div className="vector-map-tooltip-row">
          <FontAwesomeIcon icon={faTachometerAlt} fixedWidth role="img" aria-hidden={false} aria-label={strings.speed || englishStrings.speed} />
          <span>{player.speed}</span>
        </div>
      )}
      {player.navigation_distance && (
        <div className="vector-map-tooltip-row">
          <FontAwesomeIcon icon={faRoute} fixedWidth role="img" aria-hidden={false} aria-label={strings.navigation || englishStrings.navigation} />
          <span>{player.navigation_distance}</span>
        </div>
      )}
      {(player.job_source || player.job_destination) && (
        <div className="vector-map-tooltip-route">
          {player.job_source}{" > "}{player.job_destination}
        </div>
      )}
    </div>
  );
